import { render } from "./PreScriptOverlay.vue?vue&type=template&id=15904e82"
import script from "./PreScriptOverlay.vue?vue&type=script&lang=js"
export * from "./PreScriptOverlay.vue?vue&type=script&lang=js"

import "./PreScriptOverlay.vue?vue&type=style&index=0&id=15904e82&lang=scss"
script.render = render

export default script